import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { NoShowsDonut } from './NoShowsDonut';
import { NoShowsStats } from './NoShowsStats';
import { cn } from '@/utils';
import React from 'react';

interface NoShowsWidgetProps {
  data: {
    totalScheduled: number;
    show: number;
    noShow: number;
    rate: number;
  };
}

export const NoShowsWidget: React.FC<NoShowsWidgetProps> = ({ data }) => {
  const { totalScheduled, show, noShow, rate } = data;
  const isHighRate = rate > 20;

  return (
    <div className='bg-white rounded-2xl shadow-lg border border-slate-100 p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex items-center gap-3 mb-8'>
        <div
          className={cn(
            'p-3 rounded-xl transition-colors duration-500',
            isHighRate
              ? 'bg-rose-100 text-rose-600'
              : 'bg-emerald-100 text-emerald-600'
          )}
        >
          {isHighRate ? (
            <WarningIcon className='!w-5 !h-5 animate-bounce' />
          ) : (
            <CheckCircleIcon className='!w-5 !h-5' />
          )}
        </div>
        <div>
          <h3 className='text-base font-bold text-slate-500 uppercase tracking-wider'>
            Compromiso de Agenda
          </h3>
          <p className='text-xs text-slate-400 mt-0.5 font-medium'>
            Control de Ausentismo
          </p>
        </div>
      </div>

      <div className='flex-1 flex flex-col items-center justify-center gap-10'>
        <NoShowsDonut rate={rate} isHighRate={isHighRate} />

        <NoShowsStats show={show} noShow={noShow} />

        <div className='text-center pt-2'>
          <p className='text-[11px] font-bold text-slate-400 uppercase tracking-[0.1em]'>
            Total de citas agendadas:{' '}
            <span className='text-slate-900 font-black ml-1'>
              {totalScheduled}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
